class ICategory {
    public id: number = 0;
    public name: string = '';
    public description: string = '';
}

class IContractor {
    public id: string = "";
    public contractorName: string = '';
    public groupEmail: string | number = '';
    public erpId: string = '';
    public groupEmails: IGroupEmail[] = [];
}

interface IItemPrice {
    id: string;
    regionId: string;
    name: string;
    price: number;
    cost: number;
    isTaxable: boolean;
}

interface ITaxRate {
    id: string;
    rate: number;
    description: string;
}

class TaxRate implements ITaxRate {
    public id = '';
    public rate = '' as unknown as number;
    public description = '';
}

interface IRegionProductPrice extends IItemPrice{
    productId: string;
    size: string;
    unit: string;
    weight: string;
    specificGravity: string;
    category: string;
}

interface IOperatorRegionPrice extends IRegionProductPrice {
    operatorId: string;
}

interface IRegionExpensePrice extends IItemPrice{
    expenseId: string;
    isRental: boolean;
}

interface IOperatorRegionExpensePrice extends IRegionExpensePrice {
    operatorId: string;
}

class GroupEmail implements IGroupEmail {
    public id = '';
    public email = '';
    public description = '';
}

interface IGroupEmail {
    id: string;
    email: string;
    description: string;
}

class Role implements IRole {
    public id = '';
    public permissions = [] as string[];
    public description = '';
    public name = '';
}

interface IRole {
    id: string;
    name: string;
    description: string;
    permissions: string[];
}

class ISolidsControlEquip {
    public id: string = "";
    public sizeScreens: string = '';
    public deviceName: string = '';
    public makeModel: string = '';
}

class IWarehouse {
    public id: string = "";
    public name: string = '';
    public phone: string | number = '';
    public addr1: string = '';
    public addr2: string = '';
    public city: string = '';
    public state: string = '';
    public zip: string = '';
}

class IOptionFieldListItem {
    public fieldItemName: string = '';
    public id: string = '';
    public optionalFieldListId: string = '';
}

class IOptionFieldList {
    public id: string = '';
    public fieldListName: string = '';
    public optionalFieldListItems: IOptionFieldListItem[] = [];
    public routeName: string = '';
}

export {
    ICategory,
    IContractor,
    IGroupEmail,
    IOperatorRegionPrice,
    IOperatorRegionExpensePrice,
    IOptionFieldList,
    IOptionFieldListItem,
    IRegionProductPrice,
    IRegionExpensePrice,
    IRole,
    ISolidsControlEquip,
    ITaxRate,
    IWarehouse,
    GroupEmail,
    Role,
    TaxRate,
};


// WEBPACK FOOTER //
// ./src/Interfaces/AdminInterface.tsx